import React, { useState, FC, useCallback, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import { resetRequestIncognitoStatusAction } from 'actions/profile/resetRequestIncognitoStatusAction'
import { PlatformType } from 'common-constants/bowser'
import { createPhotoViewerUrl } from 'components/page/PhotoViewer/function/createPhotoViewerUrl'
import { PanelBottom } from 'components/page/PhotoViewer/Panel/PanelBottom/PanelBottom'
import { PanelTop } from 'components/page/PhotoViewer/Panel/PanelTop/PanelTop'
import { useCurrentPhotoIndex } from 'components/page/PhotoViewer/PhotoViewer.hooks'
import { PhotoViewerParams } from 'components/page/PhotoViewer/PhotoViewer.paths'
import { PhotoViewerCarousel } from 'components/page/PhotoViewer/PhotoViewerCarousel/PhotoViewerCarousel'
import { PhotoViewerNoticeMain } from 'components/page/PhotoViewer/PhotoViewerNotice/PhotoViewerNoticeMain'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { usePhotoClick } from './PhotoViewerMain.hooks'

export const PhotoViewerMain: FC = () => {
  const layoutContext = useLayoutContext()
  const { photoId, userId, promo } = useParams<PhotoViewerParams>()
  const [isShowPanel, setShowPanel] = useState<boolean>(true)
  const dispatch = useDispatch()

  const { photos, platformType, incognitoRequestStatus } =
    useShallowEqualSelector(
      ({
        photoViewerReducer: { photos },
        systemReducer: { platformType },
        profile: { incognitoRequestStatus },
      }) => ({
        photos,
        platformType,
        incognitoRequestStatus,
      })
    )

  /**
   * Очистим статус запроса к инкогнито
   */
  useEffect(
    () => {
      return () => {
        if (incognitoRequestStatus) {
          dispatch(resetRequestIncognitoStatusAction())
        }
      }
    },
    /**
     * Не добавлять incognitoRequestStatus зависимости, иначе выполняется на любое изменение incognitoRequestStatus.
     * https://youtrack.mamba.ru/issue/M-5763
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  )

  const current = useCurrentPhotoIndex()
  const { onPhotoClick } = usePhotoClick(userId)
  const [currentIndex, setCurrentIndex] = useState<number>(current)

  const baseUrlPhoto = createPhotoViewerUrl('', layoutContext)

  const handleTogglePanels = useCallback(
    (flag: boolean) => setShowPanel(flag),
    []
  )

  // console.log('PhotoViewerMain render')

  return (
    <>
      <PanelTop selectedPhotoIndex={currentIndex} isShowPanel={isShowPanel} />
      <PhotoViewerCarousel
        updateCurrentIndex={setCurrentIndex}
        togglePanels={handleTogglePanels}
        photos={photos}
        photoId={photoId}
        photoBaseUrl={baseUrlPhoto}
        showNotice={true}
        showArrows={platformType !== PlatformType.Mobile}
        notice={
          <PhotoViewerNoticeMain
            userId={userId}
            selectedPhotoIndex={currentIndex}
          />
        }
        forceShowPromo={Boolean(promo)}
        onPhotoClick={onPhotoClick}
      />
      <PanelBottom
        selectedPhotoIndex={currentIndex}
        isShowPanel={isShowPanel}
      />
    </>
  )
}
